import ApiService from "../../../services/api";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";
import property from '../chartProperties';

export default {
	data: function() {
		return {
			/* Alarms */
			pdfOptions: {
				landscape: true,
				fileName: "Allarmi",
				title: "Allarmi"
			},
			alarmsModal: false,
			alarms: [],
			alarmsData: [],
			alarmsTooltip: {
				visible: true,
				template: "#= dataItem.name # dal #= dataItem.from # al #= dataItem.to #: #= kendo.toString(value, 'n0') #"
			},
			alarmsCategoryAxis: {
				categories: [],

				majorGridLines: {
					visible: false
				}
			},
			alarmsValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						rotation: "auto",
						visible: false
					}
				}
			],
			alarmsCategoryAxisModal: {
				categories: [],

				majorGridLines: {
					visible: false
				},
				title: {
					text: "ALLARMI",
					font: "13px montserrat-light"
				},
				labels: {
					// rotation: {
					// 	angle: 45,
					// 	align: "end"
					// },
					font: "10px montserrat-light"
				}
			},
			alarmsValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "NUMERO",
						rotation: 0,
						font: "10px montserrat-light"
					},
					labels: {
						format: "n0",
						font: "10px montserrat-light"
					}
				}
			],
			alarmsChartIndex: 0,
			alarmsModalIndex: 0,
			modalTitle: "ALLARMI & ANOMALIE",
			subModalTitle: "",
			/* Alarms */

			loading: true
		};
	},
	watch: {},
	created() {
		this.getAlarms();
	},
	methods: {
		/* Alarms */
		alarmsClickHandler(e) {
			var self = this;
			this.alarmsModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				self.alarmsModalIndex++;
			}, 200);
		},
		getAlarms() {
			var self = this;
			ApiService.getAlarms().then(res => {
				self.getUserFriendlyAlarms(res);
			});
		},

		getUserFriendlyAlarms(data) {
			var self = this;

			var fieldIndex = 0;
			var item = data[0].values;

			self.alarms.push({
				name: "Allarmi",
				field: "value",
				labels: {
					visible: true,
					background: "none",
					format: "n0",
					font: "10px montserrat-light"
				}
			});

			var minValue = 10000000;
			var maxValue = 0;
			for (var prop in item) {
				var val = item[prop];
				if (maxValue < val) maxValue = val;
				if (minValue > val) minValue = val;
			}

			var maxDate = _.maxBy(data, function(o) {
				return moment(o.to);
			}).to;

			var minDate = _.minBy(data, function(o) {
				return moment(o.from);
			}).from;
			this.subModalTitle = `dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))}`;
			this.pdfOptions.fileName = helpers.chartPdffileName(this, "Allarmi_DatiDiagnosi", minDate, maxDate);
			for (var prop in item) {
				var proportion = (item[prop] * 100) / maxValue;
				var percentage = proportion / 100;
				
				self.alarmsCategoryAxisModal.categories.push(prop.replace(/ /g, "\n").toUpperCase());

				var colorValue = self.pickHex(property.alarms.colorMax, property.alarms.colorMin, percentage);

				self.alarmsData.push({
					from: self.$options.filters.dateToString(data[0].from),
					to: self.$options.filters.dateToString(data[0].to),
					value: item[prop],
					name: prop,
					color: `rgb(${colorValue})`
				});

				fieldIndex++;
			}

			setTimeout(function() {
				self.loading = false;
			}, 400);
		},

		//#endregion

		//#region Utils
		pickHex(color1, color2, weight) {
			var w1 = weight;
			var w2 = 1 - w1;
			var rgb = [Math.round(color1[0] * w1 + color2[0] * w2), Math.round(color1[1] * w1 + color2[1] * w2), Math.round(color1[2] * w1 + color2[2] * w2)];
			return rgb;
		},

		exportAsPdf() {
			// var chart = this.$refs.chartAlarmsModal.kendoWidget();
			// chart.saveAsPDF();

			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				// Custom settings for export
				transitions: false,

				// Cleanup
				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},
		createChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: self.modalTitle.toUpperCase() + " " + self.subModalTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: false
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.alarmsData
				},
				series: [
					{
						field: "value",
						name: "ALLARMI/DATI DIAGNOSI",
						labels: {
							visible: true,
							font: "13px montserrat-light",
							format: "n0"
							
						}
					}
				],
				valueAxis: {
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "NUMERO",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						font: "13px montserrat-light",
						format: "n0"
					}
				},
				categoryAxis: {
					categories: self.alarmsCategoryAxisModal.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					},
					title: {
						text: "ALLARMI",
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},

		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("alarms", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Allarmi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				// let blob = new Blob([res.data], {
				// 	type: "application/vnd.ms-excel"
				// });
				// let link = document.createElement("a");
				// var url = URL.createObjectURL(blob);
				// link.setAttribute("href", url);
				// link.setAttribute("download", "Allarmi.xlsx");
				// link.style = "visibility:hidden";
				// document.body.appendChild(link);
				// link.click();
				// document.body.removeChild(link);
			});
		}
		//#endregion
	}
};
